import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("blog-posts", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateBlogPosts = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateBlogPosts?.destroy();
  },
});
